import Vue from 'vue';
import { truncate } from '@/utilities/helpers';

Vue.filter('truncate', (value: string, length: number = 140, omission: string = '...') => truncate(value, {
	length,
	omission,
	separator: /,? +/,
}));
